import React, {useEffect} from "react";
import SubMenu from "../base/SubMenu";
import Stellenangebote from "./Stellenangebote";
import UnserTeam from "./UnserTeam";
import {useSearchParams} from "react-router-dom";


export const Karriere = (props) => {

    const stellenRef = React.createRef()
    const unserteamRef = React.createRef()

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        let scrollIntoViewValue = searchParams.get('scrollIntoView')
        if(scrollIntoViewValue === 'stellenangebote'){
            stellenRef.current.scrollIntoView()
        } else if(scrollIntoViewValue === 'unserteam'){
            unserteamRef.current.scrollIntoView()
        }

    },[searchParams]);


    return(
        <React.Fragment>

            <React.Fragment>
                <SubMenu model={{
                    background: "rgb(38, 193, 101)",
                    items: [
                        { label: "STELLENANGEBOTE", onClick: () => stellenRef.current.scrollIntoView()},
                        { label: "UNSER TEAM", onClick: () => unserteamRef.current.scrollIntoView()}                    ]
                }}/>
                <div ref={stellenRef} ><Stellenangebote/></div>
                <div ref={unserteamRef}><UnserTeam/></div>
            </React.Fragment>



        </React.Fragment>
    );
};

export default Karriere;
